const _StringTools = require("util/StringTools");

const Formatter = {
    monthNames : [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
    ],
    dayNames : [
        "Sunday", "Monday", "Tuesday",
        "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    dayNamesShort : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

    phone(str){
        str = str.replace(/\D/g,'');
        str = str.replace(/(\d{3})(\d{3})(\d{4})/, "($1)-$2-$3");
        return str;
    },

    money(str, allowNegative, doShort){
        if(!str)
            str = "";
        str = str.toString();
        if(str && str.charAt(0) == "$")
            str = str.substring(1);
        if(str && str.indexOf("$") > -1)
            str = _StringTools.searchAndReplace(str, "$", "");
        if(str && str.indexOf("-") > -1 && !allowNegative)
            str = _StringTools.searchAndReplace(str, "-", "");
        if(str && str.indexOf(",") > -1)
            str = _StringTools.searchAndReplace(str, ",", "");
        if(str.hasOwnProperty("replace"))
            str = str.replace(/[^\d.-]/g, '');
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2, /* this might not be necessary */
        });
        let retStr = formatter.format(str);
        let num = Formatter.numberFromAmount(retStr, allowNegative);

        if(num === 0)
            retStr = formatter.format("0");
        if(doShort) {
            let fracPart = num - parseInt(num);
            if (fracPart === 0)
                retStr = Formatter.shortMoney(retStr, allowNegative);
        }
        return retStr;
    },

    shortMoney(str, allowNegative){
        let m = Formatter.money(str, allowNegative);
        return m.slice(0, -3);
    },

    percentage(str, allowNegative){
        if(!str)
            str = "";
        str = str.toString();
        if(str && str.indexOf("%") > -1)
            str = _StringTools.searchAndReplace(str, "%", "");
        if(str.hasOwnProperty("replace"))
            str = str.replace(/[^\d.-]/g, '');
        let num = Formatter.numberFromAmount(str, allowNegative);
        return num + "%";
    },

    numberFromAmount(str, allowNegative){

        let num = parseFloat(str.replace(/[^\d.-]/g, ''));
        if(allowNegative){
            let isNeg = str.charAt(0) == "-";
            if(isNeg)
                num = -num;
        }
        if(isNaN(num))
            return 0;
        return (allowNegative) ? num : Math.abs(num);
    },

    dayDate(date){
        var day = this.dayNames[date.getDay()];
        var mDate = this.singleDate(date);
        return day + ", " + mDate;
    },

    singleDate(date, short, doYY){
        if(!(date instanceof Date))
            date = new Date(date);
        let day = date.getDate();
        let monthIndex = date.getMonth();
        let year = date.getFullYear();
        if(doYY){
            year = year.toString().substr(-2);
        }
        let dStr = this.monthNames[monthIndex] + " " + day + ", " + year;
        if(short){
            let mIdx = (monthIndex + 1);
            let mStr = (mIdx > 9) ? mIdx : "0" + mIdx;
            let dayStr = (day > 9) ? day : "0" + day;
            dStr = mStr + "/" + dayStr + "/" + year.toString().substr(-2);
        }
        return dStr;
    },

    htmlDate(date){
        if(!(date instanceof Date))
            date = new Date(date);
        let mDay = date.getDate();
        let wDay = this.dayNamesShort[date.getDay()];
        let month = this.monthNames[date.getMonth()];
        let year = date.getFullYear();
        let dStr = "<span class='date'>"+mDay+"</span>";
        dStr += "<span class='wk-day'>"+wDay+"</span>";
        dStr += "<span class='mo'>"+month+"</span>";
        dStr += "<span class='yy'>"+year+"</span>";
        return dStr;
    },

    monthDate(date){
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        return this.monthNames[monthIndex] + ", " + year;
    },

    yearDate(date){
        var year = date.getFullYear();
        return year;
    },

    dateRange(startDate, endDate){
        let d1 = startDate.getDate();
        let m1 = startDate.getMonth();
        let y1 = startDate.getFullYear();
        let d2 = endDate.getDate();
        let m2 = endDate.getMonth();
        let y2 = endDate.getFullYear();
        let dateStr = "";
        if(y1 === y2){
            if(m1 === m2){
                let mLb = this.monthNames[m1];
                dateStr = mLb + " " + d1 + " - " + d2 + ", " + y1;
            }
            else{
                let m1Lb = this.monthNames[m1];
                let m2Lb = this.monthNames[m2];
                dateStr = m1Lb + " " + d1 + " - " + m2Lb + " " + d2 + ", " + y1;
            }
        }
        else{
            let m1Lb = this.monthNames[m1];
            let m2Lb = this.monthNames[m2];
            dateStr = m1Lb + " " + d1 + ", " + y1 + " - " + m2Lb + " " + d2 + ", " + y2;
        }
        return dateStr;
    }
}

module.exports = Formatter;


// WEBPACK FOOTER //
// ./src/control/util/Formatter.js